export const SET_IMAGES = "SET_IMAGES";

export const setImages = data => ({ type: SET_IMAGES, data });